import { useQuery } from '@tanstack/react-query';
import { IGetDriverAddress } from "../../utils/types";
import { apiManager } from "../api-manager";
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';

export const getDriverAddress = async (driverId: string) => {
  const res = await apiManager.get<IGetDriverAddress>(
    `/admin/driver-address/${driverId}`
  );
  return res;
};



export const useGetDriverAddress = (driverId: string) =>
  useQuery({
    queryKey: ["get_driver_address", driverId],
    queryFn: async (): Promise<IGetDriverAddress> => {
      const res = await apiClient.get(ENDPOINTS.DRIVER.GET_DRIVER_ADDRESS(driverId));
      return res.data;
    },
    enabled: !!driverId,
  });